import { useQuery } from "react-query";
import { getScorecardCloseReason } from "../../../../actions/CarrierAgreementMgmt/ScoreCard";


export const useScorecardCloseReason = () => {
    const { data, isLoading, refetch } = useQuery(
        "GetScorecardCloseReason",
        getScorecardCloseReason,
        {
            refetchOnWindowFocus: false,
        }
    );

    return { data, isLoading, refetch };
};